import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ReadIconProps = Partial<SVGIconProps>;

const ReadIcon: FC<ReadIconProps> = (props) => (
  <SVGIcon viewBox="0 0 16 9" {...props}>
    <path
      d="M1.10156 5.61987L3.45251 7.50063C4.00405 7.94187 4.80399 7.87643 5.2765 7.35143L10.4349 1.61987M5.10156 5.61987L7.45251 7.50063C8.00405 7.94187 8.80399 7.87643 9.2765 7.35143L14.4349 1.61987"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </SVGIcon>
);

export default ReadIcon;
